<template>
  <code v-if="isDev" class="payment-form-debug" style="display:none;">
  {{ form }}
    <span>Admin only purposes:</span>
    Department: {{ department || '—' }}<br />
    Campaign: {{ campaign || '—' }}<br />
    SubCampaign: {{ subCampaign || '—' }}
  </code>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

const { form } = usePaymentForm()

const isDev = computed(() => {
  if (typeof window === 'undefined') return false
  return !window.location.hostname.includes('donateou.org')
})

const firstApp = computed(() => form.value?.applications?.[0] || {})
const department = computed(() => firstApp.value.department)
const campaign = computed(() => firstApp.value.campaign)
const subCampaign = computed(() => firstApp.value.subCampaign)
</script>
<style scoped>
.payment-form-debug {    flex-flow: column;font-size:12px; line-height:1.3; background: #f5f5f5; padding: 6px 15px; border: 1px solid #ddd; border-radius: 4px; margin: 10px auto; display: flex ; justify-content: center; align-items: center; max-width: fit-content; }
span {font-style: italic; padding-bottom: 2px; font-family: sans-serif; }
</style>
